import { render, staticRenderFns } from "./SlideVideo.vue?vue&type=template&id=48e0c79a&scoped=true"
import script from "./SlideVideo.vue?vue&type=script&lang=js"
export * from "./SlideVideo.vue?vue&type=script&lang=js"
import style0 from "./SlideVideo.vue?vue&type=style&index=0&id=48e0c79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0c79a",
  null
  
)

export default component.exports